import { ReactNode, Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from 'react-error-boundary'
import { queryClient } from '@/utils/reactQuery'
import { store } from '@/store/store'
import { ThemeProvider } from '@/app/providers/themeProvider'
import { Toaster } from '@/components/ui/toaster'
import { injectQueryClient, injectStore } from '@/utils/api'
import { MainErrorFallback } from '@/components/errors/mainErrorFallback'
import { AuthLoader } from './authLoader'
import { OnlineStatusProvider } from './onlineStatusProvider'
import { LoadingPage } from '@/pages/loading'

injectStore(store)
injectQueryClient(queryClient)

type AppProviderProps = {
  children: ReactNode
}

const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Suspense fallback={<LoadingPage />}>
      <ErrorBoundary FallbackComponent={MainErrorFallback}>
        <QueryClientProvider client={queryClient}>
          {import.meta.env.DEV && <ReactQueryDevtools />}
          <Provider store={store}>
            <ThemeProvider>
              <AuthLoader>
                <OnlineStatusProvider>
                  <Toaster />
                  {children}
                </OnlineStatusProvider>
              </AuthLoader>
            </ThemeProvider>
          </Provider>
        </QueryClientProvider>
      </ErrorBoundary>
    </Suspense>
  )
}

export { AppProvider }
